"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseResponse = exports.entityNotFoundHandler = exports.emptyCollectionHandler = void 0;

function emptyCollectionHandler(e) {
  if (e.code === 404) {
    return [];
  }

  throw e;
}

exports.emptyCollectionHandler = emptyCollectionHandler;

function entityNotFoundHandler(e) {
  if (e.code === 404) {
    return undefined;
  }

  throw e;
}

exports.entityNotFoundHandler = entityNotFoundHandler;

function parseResponse(response) {
  var _a;

  if ((_a = response.headers.get('Content-Type')) === null || _a === void 0 ? void 0 : _a.startsWith('application/json')) {
    return response.json();
  }

  return response.arrayBuffer();
}

exports.parseResponse = parseResponse;